// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"8f00a946","977":"14bfdd2f"}[chunkId] + ".chunk.js";
};